import React from 'react';
import moment from "./moment_fr";
import Chip from "material-ui/Chip";
import CustomPaper from "./CustomPaper";

export const OffreDetails = ({intitule, date_publication, localisation, type_contrat, descriptif}) => {

    const styles = {
        chip: {
            margin: 4,
        },
        wrapper: {
            display: 'flex',
            flexWrap: 'wrap',
            marginBottom: 5
        },
        poste_container: {
            margin: 5,
            backgroundColor: 'ghostwhite',
            border: '1px solid grey',
            padding: 12
        }
    };
    return (
        <CustomPaper title={intitule}>
            <label style={{marginLeft: 10}}>Date de publication
                : {moment(date_publication).format('LL')}</label><br/>
            <div style={styles.wrapper}>
                <Chip style={styles.chip}>{localisation}</Chip>
                <Chip style={styles.chip}>{type_contrat}</Chip>
            </div>
            <div style={styles.poste_container} dangerouslySetInnerHTML={{__html: descriptif}}/>
        </CustomPaper>
    );
};


// WEBPACK FOOTER //
// ./src/components/shared/utils/OfferDetails.js